import { render } from "./AddFleetGroupView.vue?vue&type=template&id=667f1508"
import script from "./AddFleetGroupView.vue?vue&type=script&lang=js"
export * from "./AddFleetGroupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__